module.exports = __webpack_public_path__ + "img/line-awesome.5207295c.svg";